import axios from 'axios';
import React, { useEffect, useState } from 'react';
import HitCourseZoneChart from '../../components/chart/HitCourseZoneChart';
import DefaultLoader from '../../components/loader/DefaultLoader';
import {useCookies} from 'react-cookie';
import ballImage from '../../assets/img/icon/ball_icon.png';
import dateSetting from '../../utils/dateSetting';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';

function SprayChartMain({profile}) {
    const [cookies] = useCookies(['hiball_token']);
    let [sprayData, setSprayData] = useState([]);
    let dateObj = dateSetting();
    let [season, setSeason] = useState(dateObj['selectboxSeason']);
    let [colorType, setColorType] = useState('hitResult');
    let [checkObj, setCheckObj] = useState({
        6116: true, 6101: true, 6117: true, 6111: true, 6108: true,
        6103: true, 6107: true, 6120: true, 6199: true
    });

    let todaySeason = (new Date()).getFullYear();
    const { t } = useTranslation();
    let useLang = localStorage.getItem('language');

    const ballCodeArr = [
        {name: 'fastball', code: 6116, color: '#D22D49'}, {name: 'sinker', code: 6101, color: '#FE9D00'}, 
        {name: 'cutter', code: 6117, color: '#933F2C'}, {name: 'slider', code:6111, color: '#EEE716'},
        {name: 'curve', code: 6108, color: '#00D1ED'}, {name: 'changeup', code: 6103, color: '#1DBE3A'}, 
        {name: 'splitter', code: 6107, color: '#3BACAC'}, {name: 'sweeper', code:6120, color: '#DDB33A'},
        {name: 'other', code:6199, color: '#ececec'}
    ]

    useEffect(() => {
        let {playerId} = profile;

        axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'digestBattingRecord', recordName: 'selectBatterHitSparyRecord',
                batterIds: playerId,
                seasons: season,
                gameTypeCode: 4201,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        }).then((result) => {
            let data = result['data']['result'];
            setSprayData(data);
        })
    }, [season]);

    function seasonHandler(event) {
        let value = event.target.value;
        setSeason(value);
    }

    function typeCodeHandler(event) {
        setColorType(event.target.value);
    }

    function ballCodeCheckHandler(event) {
        let id = event.currentTarget.id;
        let idSplit = id.split('-');
        let ballCode = idSplit[1];
        let checkStatus = checkObj[ballCode];

        setCheckObj({...checkObj, [ballCode]: !checkStatus})
    }

    // if(sprayData.length === 0 ) {
    //     return <DefaultLoader />
    // }

    return (
        <>
        <div style={{position:'absolute', top: '7px', left: '7px'}}>
            <Form.Group onChange={seasonHandler} style={{display:'inline-block', height: '29px'}}>
                <Form.Select size="sm" defaultValue={dateObj['selectboxSeason']}>
                    <option value={todaySeason-2}>{todaySeason-2}</option>
                    <option value={todaySeason-1}>{todaySeason-1}</option>
                    <option value={todaySeason}>{todaySeason}</option>
                </Form.Select>
            </Form.Group>
        </div>
        <div className="boxTitle">
            <img src={ballImage} style={{height:'25px'}} /> {t('sprayChart')}
        </div>
        <div style={{textAlign:'center'}}>
            <HitCourseZoneChart data={sprayData} ballCodeArr={ballCodeArr} 
            colorType={colorType} checkObj={checkObj}/>
        </div>
        <div style={{textAlign:'center'}}>
            <div style={{display:'inline-block', paddingRight: '5px'}}>{t('color')}</div>
            <div style={{display:'inline-block'}}>
                <Form.Group onChange={typeCodeHandler} style={{display:'inline-block', height: '29px'}}>
                    <Form.Select size="sm" defaultValue={'hitResult'}>
                        <option value='hitResult'>{t('hitResult')}</option>
                        <option value='ballCode'>{t('ballType')}</option>
                    </Form.Select>
                </Form.Group>
            </div>
        </div>
        <div>
        <Form>
            <div style={{display:'flex', flexWrap: 'wrap', 
            justifyContent: 'center', marginTop:'5px'}}>
            {ballCodeArr.map((item, idx) => (
                <div style={ useLang === "en" 
                    ? {width:'70px', border: `1px solid ${item['color']}`, 
                        padding: '2px 5px', borderRadius: '4px', margin: '2px', cursor:'pointer',
                        fontSize: '13px', textAlign:"center"} 
                    : {width:'70px', border: `1px solid ${item['color']}`, 
                        padding: '2px 5px', borderRadius: '4px', margin: '2px', cursor:'pointer',
                        fontSize: '13px'}}
                key={`check-${item['code']}`}
                onClick={ballCodeCheckHandler}
                id={`div-${item['code']}`}
                >
                    <Form.Check size='sm'
                    checked={checkObj[item['code']]}
                    readOnly
                    // onChange={ballCodeCheckHandler}
                    inline
                    name="group1"
                    type={'checkbox'}
                    id={`check-${item['code']}`}
                    width={'100px'}
                    style={useLang === "en" ? { marginRight:"5px", float:"left"} : {}}
                    />
                {useLang === "en" ? t(item['name']).slice(0,4) : t(item['name'])}
                </div>
            ))}
            </div>
        </Form>
        </div>
        </>
    )
}

export default SprayChartMain;